import { RequestOptions } from '@thyme/libs/src/api/types/api'
import { StrapiConfig } from './config'

// Enums
export enum StrapiStatus {
  PUBLISHED = 'published',
  DRAFT = 'draft',
}

export enum Locale {
  ENGLISH = 'en',
  SPANISH = 'es',
}

type PaginationParams = {
  pageSize: number
  page: number
}

type StrapiPopulateFields = {
  [key: string]: {
    fields: string[]
  }
}

type StrapiPopulate = {
  [key: string]: {
    populate: string | string[] | StrapiPopulate
  }
}

type StrapiPopulateContent = {
  content: {
    on: StrapiPopulate
  }
}

export type StrapiListRequestParams = {
  sort?: string[]
  populate?: StrapiPopulateFields | StrapiPopulateContent | StrapiPopulate
  fields?: string[]
  filters?: { [key: string]: { [key: string]: any } }
  pagination?: PaginationParams
  status: StrapiStatus
  locale: Locale[]
}

export type StrapiListRequestOptions = RequestOptions & {
  params: StrapiListRequestParams
}

export type CmsListFn = (
  config: StrapiConfig,
  path: string,
  options: StrapiListRequestOptions
) => Promise<ArticlesResponse | GlobalArticleFooterResponse>

// Response types
export type PaginationResponseMeta = {
  pagination: {
    pageSize: number
    page: number
    pageCount: number
    total: number
  }
}

export type ErrorResponse = {
  status: number
  name: string
  message: string
  details: { [key: string]: any }
}

export type VideoAsset = {
  documentId: string
  name: string
  url: string
  caption: string
  alternativeText: string
  mime: string
  [key: string]: string | null | number
}

export type RichTextBlock = {
  __component: 'shared.rich-text-blocks'
  id: number
  body: any[]
}

type VideoBlock = {
  __component: 'shared.video'
  id: number
  video: VideoAsset
}

type TagField = {
  name: string
}

export interface QuoteBlock {
  __component: 'shared.quote-blocks'
  id: number
  author: string
  title?: string
  body: any[]
}

type ContentBlock = RichTextBlock | VideoBlock | QuoteBlock

export type ArticleResponse = {
  documentId: string
  title: string
  slug: string
  body?: any[]
  category_sort_order?: number
  resource_category?: {
    documentId: string
    name: string
    sort_order: number
  } | null
  resource_topics?: TagField[]
  cancer_types?: TagField[]
  treatment_stages?: TagField[]
  content?: ContentBlock[]
  written_by?: string
  reviewed_by?: string
  published_date?: string
  estimated_read_time?: string
}

export type ArticlesResponse = {
  data: ArticleResponse[]
  meta: PaginationResponseMeta
}

export type StrapiImageAttributes = {
  url: string
  alternativeText?: string | null
}

export type StrapiImageRelation =
  ({ documentId: string } & StrapiImageAttributes) | null

export interface GlobalArticleFooterData {
  documentId: string
  footerContent: any[]
  createdAt: string
  updatedAt: string
  publishedAt: string
}

export interface GlobalArticleFooterResponse {
  data: GlobalArticleFooterData
  meta: object
}
